import App from 'components/App';
import { icon_wifioff } from 'components/base/images';
import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import { AppProvider } from 'contexts/AppContext';
import TranslationProvider from 'lang/TranslationProvider';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from 'store';
import { AppActions } from 'store/actionCreators';

// if (ENV_MODE_PROD) console.log = () => {};

function Root() {
  const { ipcRenderer } = window;
  const { t } = useTranslation();

  const updateOnlineStatus = () => {
    // on/off 전환
    if (!navigator.onLine) {
      AppActions.add_popup({
        isOpen: true,
        timeout: 0,
        title: <T>OFFLINE_PROHIBIT_PAGE_TITLE</T>,
        disableBackdropClick: true,
        isCloseIconButton: false,
        content: (
          <div style={{ textAlign: 'center' }}>
            <img src={icon_wifioff} />
            <CustomText fontSize={20} fontColor="#303030" marginTop={20}>
              <T>OFFLINE_NETWORK_DISCONNECT</T>
            </CustomText>
          </div>
        ),
        onClick: () => {
          ipcRenderer.send('onlineStatusChange', {
            status: navigator.onLine ? 'online' : 'offline',
          });
        },
      });
    }
  };
  useEffect(() => {
    if (ipcRenderer) {
      window.addEventListener('online', updateOnlineStatus);
      window.addEventListener('offline', updateOnlineStatus);

      updateOnlineStatus();
    }
  }, [navigator.onLine]);

  return (
    <Router basename="/">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <TranslationProvider>
            <AppProvider>
              <App />
            </AppProvider>
          </TranslationProvider>
        </PersistGate>
      </Provider>
    </Router>
  );
}
// export default hot(Root);
export default Root;
